<template>
    <div class="d-flex">
        <div>
            <div
                style="padding: 16px 12px;"
                class="d-flex justify-content-between">
                <b-button
                    style="font-size: 16px; background-color: #F1F5F9; color: #475569; font-weight: 500;"
                    class="rounded"
                    @click="resetFilter">
                    <b-icon-funnel />
                    Clear Filters
                </b-button>
                <b-form-input
                    id="filter-input"
                    v-model="filter"
                    style="font-size: 16px;"
                    class="w-50"
                    type="search"
                    placeholder="Keyword search"></b-form-input>
            </div>
            <b-table
                id="profile-table"
                :items="profiles"
                :fields="fields"
                :filter="filter"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :current-page="currentPage"
                :per-page="perPage"
                style="min-height: 260px;"
                responsive="sm"
                selectable
                sort-icon-left
                select-mode="single"
                thead-class="h4 header-text"
                details-td-class="cell-text align-middle"
                @row-selected="onRowSelected">
                <template #head(selected)="">
                    <span></span>
                </template>
                <template #cell(selected)="{ rowSelected }">
                    <template v-if="rowSelected">
                        <span
                            aria-hidden="true"
                            class="h3">&#9745;</span>
                        <span class="sr-only">Selected</span>
                    </template>
                    <template v-else>
                        <span
                            aria-hidden="true"
                            class="h3">&#9744;</span>
                        <span class="sr-only">Not selected</span>
                    </template>
                </template>
            </b-table>
            <b-pagination
                v-if="tableRows > perPage"
                v-model="currentPage"
                :total-rows="tableRows"
                :per-page="perPage"
                align="center"
                aria-controls="profile-table"
            ></b-pagination>
        </div>
        <b-button
            :disabled="!selectedProfile"
            class="align-self-end m-3"
            style="height: 48px; padding: 12px 16px; background-color: #106282;"
            @click="selectProfile">
            Continue
        </b-button>
    </div>
</template>

<script>
import PgbaBaseComponent from '../../common/components/PgbaBaseComponent.vue';

export default {
    extends: PgbaBaseComponent,
    props: {
        profiles: {
            type: Array,
            required: true
        }
    },
    data: () => {
        return {
            fields: [
                {
                    key: 'selected',
                    sortable: false,
                },
                {
                    label: 'Username',
                    key: 'userName',
                    sortable: true
                },
                {
                    label: 'Tax ID',
                    key: 'providerTaxId',
                    sortable: true
                }
            ],
            filter: '',
            selectedProfile: null,
            sortBy: '',
            sortDesc: false,
            perPage: 5,
            currentPage: 1
        };
    },
    computed: {
        tableRows() {
            return this.profiles.length;
        }
    },
    methods: {
        selectProfile() {
            if (this.selectedProfile) {
                window.location.href
                    = `/tri-inbound-sso-web/sso/select-profile?UserName=${this.selectedProfile.userName}`;
            }
        },
        onRowSelected(items) {
            this.selectedProfile = items[0];
        },
        resetFilter() {
            this.sortBy = '';
            this.sortDesc = false;
            this.filter = '';
        }
    }
};
</script>

<style>
.header-text {
    font-size: 16px !important;
}

.cell-text {
    font-size: 16px;
}
</style>